<template>
  <div>
    <form data-vv-scope="CalendarEvent">
      <vs-button color="primary" type="filled" class="float-right" @click="holidayModal = true">
        Add Holiday
      </vs-button>
      <vs-popup class="popup" :title="edit_id?'Edit Holiday':'Add Holiday'" :active.sync="holidayModal">
       
         <label class="custom_Input">Holiday Name<span class="required"></span></label>
        <vs-input
          class="custom_Input w-full"
          v-model="holiday_name"
          data-vv-name="Holiday Name"
          v-validate="'required'"
        ></vs-input>
        <div
          v-if="errors.has('CalendarEvent.Holiday Name')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.Holiday Name") }}
        </div>
        <label class="custom_Input">Start Date <span class="required"></span></label
        ><flat-pickr
          class="w-full my-1"
          icon-pack="feather"
          v-validate="'required'"
          icon="icon-calendar"
          icon-after
          data-vv-name="holiday start"
          v-model="schedule_start_date"
          :config="{dateFormat: 'Y-m-d', minDate:new Date()}"
        />
        <div
          v-if="errors.has('CalendarEvent.holiday start')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.holiday start") }}
        </div>
          <label class="custom_Input">End Date <span class="required"></span></label
          ><flat-pickr
           v-validate="'required'"
            class="w-full my-1"
            icon-pack="feather"
            icon="icon-calendar"
            icon-after
            data-vv-name="holiday end"
            :disabled="this.schedule_start_date==''"
            v-model="schedule_end_date"
            :config="{dateFormat: 'Y-m-d', minDate:this.schedule_start_date}"
          
          />
          <div
          v-if="errors.has('CalendarEvent.holiday end')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.holiday end") }}
        </div>
          <div v-if="this.schedule_end_date != ''">
             No of days: {{noOfDays}}
          </div>
       
        <vs-button class="ml-2" @click="saveEvent()">Save</vs-button>
      </vs-popup>
    </form>
    <div>
        <vs-card class="m-3">
            <vs-table class="cstm_vuexy_table" :data="holidayLIst">
            <template slot="thead">
                <vs-th style="width: 240px;"> Holiday Name </vs-th>
                <vs-th style="width: 240px;">No of Days</vs-th>
                <vs-th style="width: 300px;"> Holiday Start Date </vs-th>
                <vs-th style="width: 300px;"> Holiday End Date </vs-th>
                <vs-th style="text-align:center;width: 400px;"> Actions </vs-th>
            </template>
            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].holiday_name">
                    {{ data[indextr].holiday_name }}
                </vs-td>
                <vs-td :data="data[indextr].no_of_days">
                    {{ data[indextr].no_of_days }}
                </vs-td>
                <vs-td :data="data[indextr].start_hour">
                    {{ data[indextr].start_hour }}
                </vs-td>
                <vs-td :data="data[indextr].end_hour">
                    {{ data[indextr].end_hour }}
                </vs-td>
                <vs-td>
                    <div class="flex">
                     
                        <vs-button class="mx-1" icon-pack="feather" @click="editEvent(data[indextr].id)" icon="icon-edit"></vs-button>
                        <vs-button class="mx-1" color="danger" @click="deleteEvent(data[indextr].id)" icon-pack="feather" icon="icon-trash"></vs-button>
                        
                    </div>
                </vs-td>
                </vs-tr>
            </template>
            </vs-table>
        </vs-card>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { createHolidayApi, fetchHolidays, deleteHolidayApi } from '@/api/schedulerApi'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
export default {
  name: 'Holiday',
  components: {
    flatPickr
  },
  created () {
    this.fetchHolidaysList()
  },
  data () {
    return {   
      holidayModal: false,
      holidayLIst:[],
      customer_id:this.$store.getters.customerId,
      user_id:JSON.parse(localStorage.getItem('userInfo')).id,
      edit_id:null,
      holiday_name: '',
      noOfDays: null,
      schedule_start_date: '',
      schedule_end_date: '',
      difnoOfDays:0,
      editingObject:[]
    }
  },
  watch: {
    schedule_end_date () {
      const a = moment(this.schedule_end_date)
      const b = moment(this.schedule_start_date)
      const c = a.diff(b, 'days')
      this.noOfDays = c + 1
    },
    schedule_start_date () {
      if (this.schedule_end_date) {
        const a = moment(this.schedule_end_date)
        const b = moment(this.schedule_start_date)
        const c = a.diff(b, 'days')
        this.noOfDays = c + 1
      } else {
        this.noOfDays = 0
      }
      
    }
  },
  methods: {
    async editEvent (id) {
      try {
        const value = this.holidayLIst.find(ele => ele.id == id)
        this.editingObject = {...value}
        this.edit_id = this.editingObject.id
        this.holiday_name = this.editingObject.holiday_name
        this.noOfDays = this.editingObject.no_of_days
        this.schedule_start_date =  new Date(this.editingObject.start_hour)
        this.schedule_end_date =  new Date(this.editingObject.end_hour)
        this.holidayModal = true
      } catch (error) {
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    
    },
    async fetchHolidaysList () {
      const data = await fetchHolidays(this.user_id, this.customer_id)
      this.holidayLIst = data.data.data.holiday
    },
    saveEvent () {
  
      this.$validator.validateAll('CalendarEvent').then((valid) => {

        if (valid) {
         
          const payload = [
            {
              customer_id:this.customer_id,
              user_id:this.user_id,
              id:this.edit_id,
              start_hour: this.schedule_start_date,
              end_hour: this.schedule_end_date,
              holiday_name: this.holiday_name,
              no_of_days:parseInt(this.noOfDays)
            }
          ]
          this.savingEvent(payload)
        } else {
          this.showSuccessMessage('Error', 'Validation is Required', 'danger')
        }
        
      })
     
    },
    async savingEvent (requestParameter) {
      try {
        const customer_id = this.$store.getters.customerId
        
        const user_id = JSON.parse(localStorage.getItem('userInfo')).id
        const payload = {
          updateField:{
            holidays:requestParameter
          }
        }
        
        const data = await createHolidayApi(user_id, customer_id, payload)
        this.fetchHolidaysList()
        this.showSuccessMessage('Success', 'Holiday Added Successfully', 'success') 
        this.holidayModal = false
        this.schedule_start_date = ''
        this.schedule_end_date = ''
        this.noOfDays = ''
        this.holiday_name = ''

        
      } catch (error) {
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    },
    async deleteEvent (id) {
      
      try {
        const payload = {
          holiday_id:id
        }
        await deleteHolidayApi(this.customer_id, payload)
        this.showSuccessMessage(
          'success',
          'Holiday Deleted Successfully',
          'success'
        )
        this.fetchHolidaysList()
      } catch (error) {
        
      }
    }
  }
}
</script>
<style scoped>
.required:after {
  content: " *";
  color: red;
}
</style>